module.exports = __webpack_public_path__ + "images/stickers/taco-alert.ccbcd6ce73f50359e71a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-alert.png
// module id = SgJT
// module chunks = 1